import { EDIT_PESTS_BIOFIX_ID_insectId } from '@semios/app-platform-value-type-definitions'
import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { BiofixModal } from './BiofixModal'

type BiofixSettingsLinkProps = {
  insectId: number
  selectedProperty: number | null
}

export const BiofixSettingsTitleLink = ({ insectId, selectedProperty }: BiofixSettingsLinkProps) => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: EDIT_PESTS_BIOFIX_ID_insectId(insectId) })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="biofix-menu-item"
        data-role="menu-item"
        onClick={() =>
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              biofixModelOpened: true,
            }
          })
        }
      >
        {translate.phrases.banyanApp('Manage Biofix')}
      </ResponsiveMenuItem>
      <BiofixModal
        key="biofix-modal"
        data-role="modal"
        propertyId={Number(selectedProperty)}
        insectId={insectId}
      />
    </>,
  )

  return titleLink
}
